import HRLayout from '../../components/layout/HRLayout';
import DeptMessages from '../../components/DeptMessages';

export default function HrMessagesPage() {
  return (
    <HRLayout>
      <DeptMessages dept="HR & Compliance" color="purple" testPrefix="hr" />
    </HRLayout>
  );
}
